import { Axios } from '@/config/axios'

const state = {
  emailAlertsEnabled: true,
  emailGlobalsEnabled: true,
  isLoading: false,
}

const getters = {
  emailAlertsEnabled: state => state.emailAlertsEnabled,
  emailGlobalsEnabled: state => state.emailGlobalsEnabled,
  notificationPrefsLoading: state => state.isLoading,
}

const actions = {
  fetchPerTypePreferences({ commit }) {
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      Axios.get('/api/notification-preferences/email-types')
        .then(response => {
          const data = (response && response.data && response.data.data) || {}
          commit('SET_EMAIL_ALERTS_ENABLED', !!data.email_alerts_enabled)
          commit('SET_EMAIL_GLOBALS_ENABLED', !!data.email_globals_enabled)
          resolve(response.data)
        })
        .catch(error => reject((error && error.response) || error))
        .finally(() => commit('SET_LOADING', false))
    })
  },

  updatePerTypePreferences({ commit }, { alertsEnabled, globalsEnabled }) {
    commit('SET_LOADING', true)
    const payload = {}
    if (typeof alertsEnabled !== 'undefined') payload.email_alerts_enabled = !!alertsEnabled
    if (typeof globalsEnabled !== 'undefined') payload.email_globals_enabled = !!globalsEnabled

    return new Promise((resolve, reject) => {
      Axios.put('/api/notification-preferences/email-types', payload)
        .then(response => {
          const data = (response && response.data && response.data.data) || {}
          if (typeof data.email_alerts_enabled !== 'undefined') {
            commit('SET_EMAIL_ALERTS_ENABLED', !!data.email_alerts_enabled)
          }
          if (typeof data.email_globals_enabled !== 'undefined') {
            commit('SET_EMAIL_GLOBALS_ENABLED', !!data.email_globals_enabled)
          }
          resolve(response.data)
        })
        .catch(error => reject((error && error.response) || error))
        .finally(() => commit('SET_LOADING', false))
    })
  },
}

const mutations = {
  SET_EMAIL_ALERTS_ENABLED(state, enabled) {
    state.emailAlertsEnabled = !!enabled
  },
  SET_EMAIL_GLOBALS_ENABLED(state, enabled) {
    state.emailGlobalsEnabled = !!enabled
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = !!isLoading
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
